import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "no-options" };
const _hoisted_2 = { class: "pagination" };
const _hoisted_3 = ["disabled"];
const _hoisted_4 = ["disabled"];
const _hoisted_5 = { class: "pagination__total" };
import { ref, watch } from 'vue';
import paloma from '../../services/PalomaBackend';
import env from '../../services/AppEnv';
import log from "../../services/Logger";
import { numberFilter } from "../../util/CommonUiFilters";
import { createPopper } from '@popperjs/core';
import VSelect from 'vue-select';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlEntity',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change'
    ],
    setup(__props, { emit: __emit }) {
        const http = paloma.http;
        const props = __props;
        const emit = __emit;
        const model = ref(undefined);
        const fieldOptions = props.field.options || {};
        const selectOptions = ref([]);
        const optionsPage = ref(null);
        const dataUrl = ref(null);
        const searchQuery = ref('');
        if (Array.isArray(fieldOptions.data)) {
            initModel();
            updateModel(fieldOptions.data);
            selectOptions.value = fieldOptions.data;
        }
        else if (fieldOptions.data) {
            // must be FormFieldDataSource
            const dataSource = fieldOptions.data;
            dataUrl.value = dataSource.url;
            initModel();
            loadOptions();
        }
        // TODO debounce?
        function fetchOptions(search, loading) {
            if (!dataUrl.value) {
                return;
            }
            searchQuery.value = search || '';
            if (optionsPage.value) {
                optionsPage.value.number = 0;
            }
            loading(true);
            loadOptions()
                .finally(() => loading(false));
        }
        async function loadOptions() {
            try {
                let response = await http
                    .get(dataUrl.value, {
                    params: {
                        query: searchQuery.value,
                        page: (optionsPage.value && optionsPage.value.number) || 0,
                        size: (optionsPage.value && optionsPage.value.size) || 10,
                        locale: env.locale,
                    },
                });
                updateModelFromResponse(response);
                if (Array.isArray(response.data)) {
                    selectOptions.value = response.data;
                }
                else {
                    // assume Page<T>
                    selectOptions.value = response.data.content;
                    optionsPage.value = response.data;
                }
            }
            catch (e) {
                // TODO
            }
        }
        function updateModelFromResponse(response) {
            if (Array.isArray(response.data)) {
                updateModel(response.data);
            }
            else {
                // assume Page<T>
                updateModel(response.data.content);
            }
        }
        function updateModel(data) {
            // if we already have one or multiple model.value entries and get new
            //   options, we want to check whether those options contain one of the
            //   selected entries. If yes, we want to use the options values,
            //   because they might be more current.
            if (model.value) {
                if (Array.isArray(model.value)) {
                    for (let i = 0; i < model.value.length; i++) {
                        const value = model.value[i];
                        if (value) {
                            let currentOption = data.find(option => option.id === value.id);
                            if (currentOption) {
                                model.value[i] = currentOption;
                            }
                        }
                    }
                }
                else {
                    const value = model.value;
                    let currentOption = data.find(option => option.id === value.id);
                    if (currentOption) {
                        model.value = currentOption;
                    }
                }
            }
        }
        /**
         * For FormFieldDataSource (`dataUrl` is set), we fetch all selected
         * values from the server each time the input model changes.
         */
        function loadModelOptions() {
            const value = model.value;
            if (value && dataUrl.value) {
                if (Array.isArray(value)) {
                    // FormFieldDataItem[]
                    // empty array won't get here!
                    return Promise.all(value.map(v => loadModelOption(v.id)));
                }
                else if (typeof value === 'object') {
                    // FormFieldDataItem
                    let item = value;
                    return loadModelOption(item.id);
                }
            }
            return Promise.resolve();
        }
        async function loadModelOption(id) {
            if (id == null) {
                return;
            }
            try {
                let response = await http
                    .get(dataUrl.value, {
                    params: {
                        query: "id:" + escapeQueryArg(id),
                        page: (optionsPage.value && optionsPage.value.number) || 0,
                        size: (optionsPage.value && optionsPage.value.size) || 10,
                        locale: env.locale,
                    },
                });
                updateModelFromResponse(response);
            }
            catch (e) {
                console.error("Failed to fetch selected value with id = " + id + " from " + dataUrl.value);
            }
        }
        function escapeQueryArg(id) {
            return `"${id.replace('"', '\"')}"`;
        }
        watch(() => props.data, initModel);
        function initModel() {
            model.value = props.field.options?.entityReference === 'identifier'
                ? { id: props.data, name: props.data }
                : props.data;
            if (!model.value && fieldOptions.multiple) {
                model.value = [];
            }
            loadModelOptions();
        }
        function onChange(newValue) {
            let value = newValue;
            if (props.field.options?.entityReference === 'identifier' && value != null) {
                value = value['id'];
            }
            log('FieldControlEntity@change', props.field.name, value);
            emit('change', value);
        }
        function prevPage() {
            optionsPage.value.number--;
            loadOptions();
        }
        function nextPage() {
            optionsPage.value.number++;
            loadOptions();
        }
        function withPopper(dropdownList, component, {}) {
            /**
             * Here we position the dropdownList relative to the $refs.toggle Element.
             *
             * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
             * the dropdownList overlap by 1 pixel.
             *
             * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
             * wrapper so that we can set some styles for when the dropdown is placed
             * above.
             *
             * The 'sameWidth' modifier ensures that the drop-down's width remains
             * equal to the width of the $refs.toggle Element (e.g. when the user
             * resizes the browser).
             */
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: 'bottom',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({ state }) {
                            component.$el.classList.toggle('drop-up', state.placement === 'top');
                        },
                    },
                    {
                        name: "sameWidth",
                        enabled: true,
                        phase: "beforeWrite",
                        requires: ["computeStyles"],
                        fn: ({ state }) => {
                            state.styles.popper.width = `${component.$refs.toggle.clientWidth}px`;
                        },
                        effect: ({ state }) => {
                            state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
                        }
                    }
                ],
            });
            /**
             * To prevent memory leaks Popper needs to be destroyed.
             * If you return function, it will be called just before dropdown is removed from DOM.
             */
            return () => popper.destroy();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(VSelect), {
                modelValue: model.value,
                "onUpdate:modelValue": onChange,
                onSearch: fetchOptions,
                inputId: __props.fieldId,
                filterable: !dataUrl.value,
                disabled: _unref(fieldOptions).disabled,
                clearable: !_unref(fieldOptions).required,
                multiple: _unref(fieldOptions).multiple,
                options: selectOptions.value,
                appendToBody: true,
                "calculate-position": withPopper,
                label: "name"
            }, _createSlots({
                "no-options": _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('grid.no_search_results')), 1)
                ]),
                _: 2
            }, [
                (optionsPage.value && optionsPage.value.totalPages > 1)
                    ? {
                        name: "list-footer",
                        fn: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("button", {
                                    disabled: !optionsPage.value || optionsPage.value.first,
                                    onClick: _withModifiers(prevPage, ["prevent"]),
                                    href: "",
                                    class: "pagination__btn"
                                }, _toDisplayString(_ctx.$t('prev')), 9, _hoisted_3),
                                _cache[0] || (_cache[0] = _createTextVNode()),
                                _createElementVNode("button", {
                                    disabled: !optionsPage.value || optionsPage.value.last,
                                    onClick: _withModifiers(nextPage, ["prevent"]),
                                    href: "",
                                    class: "pagination__btn"
                                }, _toDisplayString(_ctx.$t('next')), 9, _hoisted_4),
                                _cache[1] || (_cache[1] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_5, "\n                    (" + _toDisplayString(_unref(numberFilter)(optionsPage.value?.totalElements)) + " " + _toDisplayString(_ctx.$t('total')) + ")\n                ", 1)
                            ])
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032, ["modelValue", "inputId", "filterable", "disabled", "clearable", "multiple", "options"]));
        };
    }
});
